import { de } from "@ainkauf/core";

/**
 * Alles abgehakt. Ein kleiner Moment der Freude statt einer Meldung: Wer die
 * Liste leer gemacht hat, hat etwas geschafft.
 */
export function AllDone() {
  return (
    <div className="karte flex flex-col items-center gap-3 px-6 py-10 text-center">
      <svg width="92" height="84" viewBox="0 0 92 84" fill="none" aria-hidden>
        <circle cx="46" cy="40" r="28" fill="var(--herb-soft)" />
        <path d="M33 41.5 42.5 51 60 32" stroke="var(--herb)" strokeWidth="6.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="20" r="4" fill="var(--food-golden)" />
        <circle cx="80" cy="16" r="5" fill="var(--accent)" opacity="0.85" />
        <circle cx="76" cy="66" r="3.5" fill="var(--food-sea)" />
        <circle cx="16" cy="64" r="4.5" fill="var(--food-basil)" opacity="0.9" />
      </svg>
      <p className="font-display text-xl font-extrabold tracking-tight text-ink">{de.lists.allDone}</p>
      <p className="text-ink-2">{de.lists.allDoneHint}</p>
    </div>
  );
}
